import AssetMainDetails from './AssetMainDetails'
export default AssetMainDetails
